import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { PageHeader } from "@/shared/components/PageHeader";
import { TaskScheduleFormModal } from "../components/TaskScheduleFormModal";
import { TaskScheduleTable } from "../components/TaskScheduleTable";
import { useTaskScheduleStore } from "../store/task-schedule.store";

export function TaskSchedulePage() {
	const onOpen = useTaskScheduleStore((s) => s.onOpen);

	return (
		<div>
			<PageHeader
				title="Takrorlanish (Topshiriq jadvallari)"
				action={
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={() => onOpen()}
						id="task-schedule-create-btn"
					>
						Qo&apos;shish
					</Button>
				}
			/>
			<TaskScheduleTable />
			<TaskScheduleFormModal />
		</div>
	);
}
